import { type FC } from "react";

import { MarketGroupsMenu } from "~/feature/chart/components/MarketGroupsMenu";
import { isWholeGroupSelected } from "~/feature/chart/utils";
import type { IMarket } from "~/types/event";

import { maxLinesBanner } from "./constants";
import { useMarketDropdownMenu } from "./useMarketDropdownMenu";

interface IMarketsDropdownMenuProps {
  markets: IMarket[];
  selections: string[];
  isConsensusMode: boolean;
  onToggle: (marketId: string) => void;
  onSelectConsensus: (marketId: string) => void;
  onClose: () => void;
}

export const MarketsDropdownMenu: FC<IMarketsDropdownMenuProps> = ({
  markets,
  selections,
  isConsensusMode,
  onToggle,
  onSelectConsensus,
  onClose,
}) => {
  const { groups, isMaxSelected, handleGroupClick } = useMarketDropdownMenu({
    markets,
    selections,
    onToggle,
  });

  return (
    <MarketGroupsMenu
      groups={groups}
      selectedIds={selections}
      isConsensusSelected={({ markets: groupMarkets }) =>
        isConsensusMode && isWholeGroupSelected(groupMarkets, selections)
      }
      banner={isMaxSelected ? maxLinesBanner : undefined}
      onGroupClick={handleGroupClick}
      onMarketClick={(_, marketId) => onToggle(marketId)}
      onConsensusClick={({ markets: [firstMarket] }) => {
        onSelectConsensus(firstMarket.id);
        onClose();
      }}
    />
  );
};
